module.exports = __webpack_public_path__ + "static/img/samajuri (37).1f32e80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (37).jpg
// module id = 0rgY
// module chunks = 0